import { ToastProps } from 'react-toast-notifications';
import { Alert, Snackbar } from '@mui/material';

export const CustomToast = ({ appearance, children, isRunning }: ToastProps) => (
  <Snackbar
    sx={{ top: '72px !important' }}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    open={isRunning}
    autoHideDuration={7000}
  >
    <Alert severity={appearance}>{children}</Alert>
  </Snackbar>
);
